module.exports = __webpack_public_path__ + "media/country_flags/ar-12fdf7eb.png";